export const EventHeroText = {
  en: {
    preTitle: "",
    name: "Business Events",
  },

  vi: {
    preTitle: "",
    name: "Sự Kiện Doanh Nghiệp",
  },
};

export const missionEventText = {
  en: {
    title: "Connect, collaborate, and grow ",

    description: "",
  },

  vi: {
    title: "Kết nối, hợp tác và phát triển",

    description: "",
  },
};

export const BusinessEventText = {
  en: {
    title: "Business Events",
    secondTitle: "Workshops",

    intro: [
      "Connect, collaborate, and grow through premium business networking and corporate events designed to inspire success.",

      "Bringing business owners, professionals, and industry leaders together to create meaningful opportunities and lasting partnerships.",

      "Professional business functions that foster networking, innovation, and business growth across New Zealand and Australia.",
    ],

    body: [
      "We design practical workshops to help SMEs move from survival to sustainable growth and success.",

      "Gain real business strategies, hands-on learning, and actionable insights from experienced industry professionals.",

      "Empowering business owners with the tools, systems, and knowledge to scale confidently and improve results.",
    ],

    links: {
      businessEvent: {
        label: "Upcoming Event",
        url: "https://sunwave.eventbrite.com/",
      },

      workshop: {
        label: "Upcoming Workshop",
        url: "https://www.eventbrite.co.nz/e/from-survival-to-scale-business-and-networking-tickets-1988894612325",
      },
    },
  },

  vi: {
    title: "Sự Kiện Doanh Nghiệp",
    secondTitle: "Workshop",

    intro: [
      "Kết nối, hợp tác và phát triển thông qua các sự kiện networking doanh nghiệp và chương trình chuyên nghiệp được thiết kế nhằm truyền cảm hứng cho thành công.",

      "Kết nối các chủ doanh nghiệp, chuyên gia và lãnh đạo trong ngành để tạo ra những cơ hội ý nghĩa và các mối quan hệ hợp tác lâu dài.",

      "Các sự kiện doanh nghiệp chuyên nghiệp thúc đẩy networking, đổi mới và tăng trưởng kinh doanh tại New Zealand và Australia.",
    ],

    highlight:
      "Những kết nối kinh doanh mạnh mẽ sẽ tạo ra nhiều cơ hội, đổi mới và thành công bền vững hơn.",

    body: [
      "Chúng tôi thiết kế các workshop thực tiễn nhằm giúp SMEs chuyển mình từ giai đoạn tồn tại sang tăng trưởng và thành công bền vững.",

      "Tiếp cận các chiến lược kinh doanh thực tế, học tập thực hành và những kiến thức có thể áp dụng ngay từ các chuyên gia giàu kinh nghiệm.",

      "Trao quyền cho chủ doanh nghiệp thông qua công cụ, hệ thống và kiến thức cần thiết để mở rộng doanh nghiệp tự tin và hiệu quả hơn.",
    ],

    links: {
      businessEvent: {
        label: "Sự Kiện Sắp Tới",
        url: "https://sunwave.eventbrite.com/",
      },

      workshop: {
        label: "Workshop Sắp Tới",
        url: "https://www.eventbrite.co.nz/e/from-survival-to-scale-business-and-networking-tickets-1988894612325",
      },
    },
  },
};

export const PrivateSectionText = {
  en: {
    title: "Private Session",

    intro: [
      "Personalised one-on-one business sessions tailored to your unique goals, challenges, and growth opportunities.",

      "Strategic private coaching and advisory sessions focused on improving performance, profitability, and business direction.",

      "Confidential business guidance designed to help you make smarter decisions and achieve measurable results faster.",
    ],

    highlight:
      "We believe every business owner deserves clear direction, practical strategies, and personalised support to achieve sustainable success.",
  },

  vi: {
    title: "Tư Vấn Riêng",

    intro: [
      "Các buổi tư vấn 1-1 được cá nhân hoá dựa trên mục tiêu, thách thức và cơ hội phát triển riêng của doanh nghiệp bạn.",

      "Các buổi coaching và cố vấn chiến lược tập trung vào việc cải thiện hiệu suất, lợi nhuận và định hướng phát triển doanh nghiệp.",

      "Các buổi tư vấn bảo mật giúp bạn đưa ra quyết định thông minh hơn và đạt được kết quả rõ ràng nhanh hơn.",
    ],

    highlight:
      "Chúng tôi tin rằng mỗi chủ doanh nghiệp đều cần có định hướng rõ ràng, chiến lược thực tiễn và sự đồng hành phù hợp để đạt được thành công bền vững.",
  },
};

export const BookingSectionText = {
  en: {
    title: "Book Your Session",
    office: "Head Office",
    sessionTitle: "Book Your Session",

    sessions: [
      {
        title: "Complimentary Business Growth Review",
        duration: "30 Minutes FREE",
        button: "Send Your Enquiry",
        link: "email",
      },

      {
        title: "Business Strategy & Growth Planning Session",
        duration: "90 Minutes NZ$265",
        button: "Book Now",
        link: "https://www.paypal.com/ncp/payment/Q6T6NEXQMM2AJ",
      },

      {
        title: "Leadership & Management Development Session",
        duration: "120 Minutes NZ$385",
        button: "Book Now",
        link: "https://www.paypal.com/ncp/payment/CHZH6JXB4G32W",
      },
    ],
    call: "Call Now",
    book: "Send your Enquiry",
    contacting: "You are contacting us about:",
    formIntro:
      "Share your details and Maria will contact you to arrange a planning session for your business.",
    name: "Name *",
    tel: "Tel *",
    email: "Email *",
    company: "Company",
    subject: "Subject / Detail",
    timetable: "Preferred Timetable",
    timetablePlaceholder: "Example: Monday or Wednesday afternoon",
    submit: "Submit Request",
    workshop: "Workshop enquiry:",
  },

  vi: {
    title: "Liên hệ",
    office: "Trụ sở chính",
    sessionTitle: "Đặt Lịch Tư Vấn",

    sessions: [
      {
        title: "Đánh Giá Tăng Trưởng Doanh Nghiệp",
        duration: "30 phút MIỄN PHÍ",
        button: "Gửi Yêu Cầu",
        link: "/contact",
      },

      {
        title: "Tư Vấn Chiến Lược & Kế Hoạch Phát Triển Doanh Nghiệp",
        duration: "90 phút NZ$265",
        button: "Đặt Lịch",
        link: "https://www.paypal.com/ncp/payment/Q6T6NEXQMM2AJ",
      },

      {
        title: "Tư Vấn Phát Triển Lãnh Đạo & Quản Lý",
        duration: "120 phút NZ$385",
        button: "Đặt Lịch",
        link: "https://www.paypal.com/ncp/payment/CHZH6JXB4G32W",
      },
    ],
    call: "Gọi ngay",
    book: "Gửi yêu cầu",
    contacting: "Bạn đang liên hệ về:",
    formIntro:
      "Hãy để lại thông tin, Maria sẽ liên hệ với bạn để sắp xếp một buổi tư vấn cho doanh nghiệp của bạn.",
    name: "Họ tên *",
    tel: "Điện thoại *",
    email: "Email *",
    company: "Công ty",
    subject: "Nội dung",
    timetable: "Thời gian mong muốn",
    timetablePlaceholder: "Ví dụ: Thứ Hai hoặc chiều Thứ Tư",
    submit: "Gửi yêu cầu",
    workshop: "Quan tâm workshop:",
  },
};
